import { render } from "./ErrorDialog.vue?vue&type=template&id=2afe4729"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ErrorDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2afe4729"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2afe4729', __exports__)) {
    api.reload('2afe4729', __exports__)
  }
  
  module.hot.accept("./ErrorDialog.vue?vue&type=template&id=2afe4729", () => {
    api.rerender('2afe4729', render)
  })

}


export default __exports__